
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_9498_30139)"}},[_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"mask0_9498_30139","maskUnits":"userSpaceOnUse","x":"-4","y":"-4","width":"24","height":"24"}},[_c('rect',{attrs:{"x":"-4","y":"-4","width":"24","height":"24","fill":"#D9D9D9"}})]),_c('g',{attrs:{"mask":"url(#mask0_9498_30139)"}},[_c('path',{attrs:{"d":"M2.40106 14.308L1.69336 13.6003L7.29336 8.00033L1.69336 2.40033L2.40106 1.69263L8.00106 7.29263L13.6011 1.69263L14.3088 2.40033L8.70876 8.00033L14.3088 13.6003L13.6011 14.308L8.00106 8.70803L2.40106 14.308Z","fill":"black"}})])]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_9498_30139"}},[_c('rect',{attrs:{"width":"16","height":"16","fill":"white"}})])])])
          )
        }
      }
    